import React from 'react';

export default class ReadIcon extends React.Component {
  render() {
    return (
      <svg
        className='result-footer-icon read-icon'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='-1378.033 1832 15.753 15.85'
      >
        <path
          d='M15.587,13.5l-2.8-2.8a5.868,5.868,0,0,0,1.2-3.7A6.954,6.954,0,0,0,6.994,0,6.954,6.954,0,0,0,0,7a6.954,6.954,0,0,0,6.994,7,7.032,7.032,0,0,0,3.8-1.1l2.8,2.8a.483.483,0,0,0,.7,0l1.4-1.4A.755.755,0,0,0,15.587,13.5ZM6.994,12A4.949,4.949,0,0,1,2,7a4.949,4.949,0,0,1,5-5,4.949,4.949,0,0,1,5,5A4.949,4.949,0,0,1,6.994,12Z'
          transform='translate(-1378.033 1832)'
        />
      </svg>
    );
  }
}
